export default "__VITE_ASSET__6_WBao6V__"